import { render, staticRenderFns } from "./index.vue?vue&type=template&id=057832a6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=057832a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057832a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MediaSubNav: require('/app/components/media-sub-nav.vue').default,SocialShareBtns: require('/app/components/social-share-btns.vue').default,MediaListingStyle: require('/app/components/content-elements/media-listing-style.vue').default,MediaItemsWithSearch: require('/app/components/loading-placeholders/media-items-with-search.vue').default,MostSharesImages: require('/app/components/content-elements/most-shares-images.vue').default})
